<template><warehouse-operation-page kind="adjustment" /></template>
<script>import WarehouseOperationPage from './WarehouseOperationPage.vue'; export default { name: 'WarehouseAdjustmentOperation', components: { WarehouseOperationPage } }</script>
